"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = void 0;
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};
exports.sizes = sizes;